export const RoundedChecklistIcon = ({ color = "#8D8D8D", size = 20, ...props }) => (
    <svg width={size} height={size} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M11 0C4.928 0 0 4.928 0 11C0 17.072 4.928 22 11 22C17.072 22 22 17.072 22 11C22 4.928 17.072 0 11 0ZM8.8 16.5L3.3 11L4.851 9.449L8.8 13.387L17.149 5.038L18.7 6.6L8.8 16.5Z" fill={color} />
    </svg>

);
